var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 16,
    rx: 8,
    fill: "#EDF1FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5v7m0 0l3.5-3.5M12 12L8.5 8.5",
    stroke: "#476FF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAyNCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeT0iMC41IiB3aWR0aD0iMjQiIGhlaWdodD0iMTYiIHJ4PSI4IiBmaWxsPSIjRURGMUZDIi8+CjxwYXRoIGQ9Ik0xMiA1VjEyTTEyIDEyTDE1LjUgOC41TTEyIDEyTDguNSA4LjUiIHN0cm9rZT0iIzQ3NkZGMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgBudge as ReactComponent };